export class District {
    constructor(public id: string, public cityid: string, public name: string) { }
  }
  